import React from "react";
import { motion } from "framer-motion";

const quotes = [
  { name: "Aanya, Delhi", text: "FinBit helped me spot recurring subscriptions I forgot about — saved ₹1200/month!" },
  { name: "Rohit, Pune", text: "Automatic SMS parsing is a game changer for hostel life." },
  { name: "Priya, Mumbai", text: "Budget nudges stopped my late-night food orders. Highly recommend." },
];

export default function Testimonials(){
  return (
    <section id="testimonials" className="py-10">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold">What students say</h3>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {quotes.map((q, i) => (
            <motion.blockquote
              key={i}
              initial={{opacity:0, y:12, scale:0.98}}
              whileInView={{opacity:1, y:0, scale:1}}
              viewport={{once:true}}
              transition={{delay: i * 0.06, duration:0.45}}
              className="p-6 rounded-xl glass border border-gray-100 dark:border-gray-800 neon-hover"
            >
              <p className="text-sm text-gray-700 dark:text-gray-200">“{q.text}”</p>
              <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">— {q.name}</div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
